import Login from "../views/Login.svelte";
import Menu from "../views/Menu.svelte";
import DspMng from "../views/DspMng.svelte";
import ShipMng from "../views/ShipMng.svelte";
import RcpMng from "../views/RcpMng.svelte";
import DspList from "../views/DspList.svelte";
import RcpList from "../views/RcpList.svelte";

export const mainRoutres = {
    "/login": Login,
    "/Menu": Menu,
    "/DspMng": DspMng,
    "/ShipMng": ShipMng,
    "/RcpMng": RcpMng,
    "/DspList": DspList,
    "/RcpList": RcpList,
};
